var scope_0 = require('/home/runner/work/design/design/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/842c9b4399ff60a1bdfcdeb3eb6116ef.js').default;
var scope_1 = require('/home/runner/work/design/design/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/843a44963cafbd53f6567ee7e8128310.js').default;
var scope_2 = require('/home/runner/work/design/design/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c50355c9950c6e76e0c67a2e34e904d9.js').default;
var scope_3 = require('/home/runner/work/design/design/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3 )
    